import { useSelector } from "react-redux";
import { selectAuthStatus } from "../store/auth";

export const useUserState = () => {
  const status = useSelector((state) => selectAuthStatus(state));
  return status;
};
